import { memo } from 'react'
import { DgtPdOrderPicklistMovement } from '../models'
import { EditorProps } from 'react-data-grid'
import Modal from './Modal'
import { formatDateFromUnix, formatNumberV2 } from '../utilities/Format'
import { AiFillCloseCircle } from 'react-icons/ai'

const QACheckConfirmEditor = memo(({ props, isChecked } : {
  props: EditorProps<DgtPdOrderPicklistMovement>, isChecked: boolean
}) => {
  const { onClose, onRowChange, row } = props

  return isChecked ? <Modal show={true} onHide={onClose}
    okTheme='danger'
    okText='ยกเลิก'
    okAction={() => {
      let updatedRow = { ...row }
      delete updatedRow.qualityCheckedDateTime
      onRowChange(updatedRow, true)
    }}
    cancelText='ปิด'
    title={`ยกเลิกการตรวจราย Item`}
    >
      <div className='flex items-center gap-2'>
        <AiFillCloseCircle size={50} className='text-red-500 basis-1/6 ' />
        <div className='space-y-2 basis-5/6'>
          <h6>คุณกำลังต้องการยกเลิกที่เคยตรวจของ </h6>
          <h5 className='font-bold underline '>{row.materialCode} - {row.materialDescription}</h5>
          <h6>ใช่หรือไม่ ?</h6>
        </div>
      </div>
    </Modal> :
    <Modal show={true} onHide={onClose}
      okTheme='success'
      okText='ผ่าน'
      okAction={() => {
        const updatedRow = { ...row,
          qualityCheckedDateTime: Math.floor(Date.now() / 1000)
        }
        onRowChange(updatedRow, true)
      }}
      cancelText='รอก่อน'
      title={`${row.materialCode} - ${row.materialDescription}`}
      >
      <>
      <div className='grid grid-cols-3 mb-3'>
        <h6>PD ORDER#</h6>
        <h6 className='col-span-2 font-bold'>{row.orderId}</h6>
        <h6>เบิก</h6>
        <h6 className='col-span-2 font-bold '>{formatNumberV2(row.materialRequestQty)} {row.materialUnit}</h6>
        <h6>จ่าย</h6>
        <h6 className='col-span-2 font-bold text-green-500 '>{formatNumberV2(row.amount)} {row.materialUnit}</h6>
        <h6>Batch Lot</h6>
        <h6 className='col-span-2 font-bold '>{row.batchLotNo}</h6>
        <h6>PD ตรวจเมื่อ</h6>
        <h6 className='col-span-2 font-bold '>{formatDateFromUnix(row.checkedDateTime)} / {row.checkedBy}</h6>
      </div>
      <h6>ตรวจสอบแล้วให้ผ่านหรือไม่ ?</h6>
      </>
    </Modal>
})

export default memo(QACheckConfirmEditor)